<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="inline">
      <h4 class="modal-title">
        {{ 'components.sendEmailMessage.title' | translate }}
      </h4>
      @if (shouldRenderTooltip) {
        <app-tooltip [marginBottom]="false" text="sendEmailMessageBackoffice" />
      }
    </div>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    @if (isCrudLoading) {
      <div class="lna-spinner">
        <app-spinner [isLoading]="isCrudLoading"></app-spinner>
      </div>
    }
    <form [formGroup]="form" [ngClass]="{ hidden: isCrudLoading }">
      <div class="lna-row-32 full-width">
        <label class="form-label lna" for="email">
          {{ 'components.sendEmailMessage.email' | translate }}
          <span class="required-field">*</span>
        </label>
        <input
          class="form-control lna email-input"
          id="email"
          [ngClass]="{ invalid: shouldRenderError('email') }"
          type="email"
          formControlName="email"
          name="email" />
        @if (getErrorMessage('email'); as errorMessage) {
          <div class="error-wrapper">
            <small class="error-message">{{ errorMessage | translate }}</small>
          </div>
        }
      </div>
      <div class="lna-row-32 full-width">
        <label class="form-label lna" for="emailSubject">
          {{ 'components.sendEmailMessage.emailSubject' | translate }}
          <span class="required-field">*</span>
        </label>
        <input
          class="form-control lna"
          id="emailSubject"
          [ngClass]="{ invalid: shouldRenderError('emailSubject') }"
          type="text"
          formControlName="emailSubject"
          name="emailSubject" />
        @if (getErrorMessage('emailSubject'); as errorMessage) {
          <div class="error-wrapper">
            <small class="error-message">{{ errorMessage | translate }}</small>
          </div>
        }
      </div>
      <div class="lna-row-32 full-width">
        <div class="label-wrapper">
          <label class="form-label lna" for="backofficeText">
            {{ 'components.sendEmailMessage.backofficeText' | translate }}
            <span class="required-field">*</span>
          </label>
        </div>
        <div class="textarea-wrapper">
          <textarea
            class="form-control lna"
            id="backofficeText"
            [ngClass]="{ invalid: shouldRenderError('backofficeText') }"
            type="text"
            formControlName="backofficeText"
            name="backofficeText"
            required
            maxlength="{{ maxFieldLength }}"></textarea>
          <p
            class="length"
            [ngClass]="{
              invalid: backofficeText?.value.length > maxFieldLength
            }">
            {{ backofficeText?.value.length }}/{{ maxFieldLength }}
          </p>
        </div>
        @if (getErrorMessage('backofficeText'); as errorMessage) {
          <div class="error-wrapper">
            <small class="error-message">
              {{ errorMessage | translate }}
            </small>
          </div>
        }
      </div>
      <div class="lna-row-32 value-wrapper file-list">
        <label class="form-label lna">{{ 'components.sendEmailMessage.attachments' | translate }}</label>
        <app-file-upload
          [isEditMode]="true"
          [existingFiles]="[]"
          [type]="communicationFileType"
          [associatedEntityId]="informationRequest.id"
          [isSubmitting]="false"
          [showDescription]="false"
          (filesChanged)="onFilesChanged($event)" />
      </div>
    </form>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="isCrudLoading" (click)="submit()" type="button">
      {{ 'components.sendEmailMessage.send' | translate }}
    </button>
    <button class="secondary" (click)="close()" type="button">
      {{ 'components.sendEmailMessage.cancel' | translate }}
    </button>
  </div>
</ng-template>
